import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './App';

import '~/axiosConfig';
import './index.css';
import './translation/i18n';
import { Providers } from '~/Providers';

// console.log('Environment-------+-:', import.meta.env);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Providers>
      <App />
    </Providers>
  </React.StrictMode>
);
